import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import FAQ from "../../components/FAQ";
import MNR from "../../asstes/MNR.png";
import {
  BookOpen,
  GraduationCap,
  Crown,
  Building2,
  CheckCircle2,
} from "lucide-react";
import Navbar from "../../components/PSTVue/Navbar2";

const getPlans = (isAnnual) => [
  {
    name: "Free",
    icon: <BookOpen size={28} />,
    monthlyPrice: { INR: 0, USD: 0 },
    semiAnnualPrice: { INR: 0, USD: 0 },
    duration: "/ 14 Days",
    desc: "Experience our AI study assistant to solve your doubts completely free.",
    features: [
      "20 AI Chat Queries", // Updated to 20
      "14-Day Platform Access",
      "Text & PDF Document Uploads",
      "Step-by-step Explanations",
      "Standard Response Speed",
    ],
    buttonText: "Start Trial",
    theme: {
      cardBg: "bg-slate-800/60 backdrop-blur-sm",
      borderColor: "border-slate-700",
      iconColor: "text-slate-300 bg-slate-700/50",
      btnColor: "bg-slate-700 hover:bg-slate-600 text-white",
      textColor: "text-slate-300",
      priceColor: "text-white",
    },
  },
  {
    name: "Basic",
    icon: <GraduationCap size={28} />,
    monthlyPrice: { INR: 1000, USD: 12 },
    semiAnnualPrice: { INR: 5400, USD: 64.8 },
    duration: isAnnual ? "/ 6 months" : "/ month",
    desc: "Perfect for regular students needing consistent homework help and document analysis.",
    features: [
      `${isAnnual ? "3,000" : "500"} AI Chat Queries`, // Updated to 500/3000
      "Advanced PDF Parsing",
      "Detailed Question Analysis",
      "Chat History Retention",
      "Faster Response Times",
    ],
    buttonText: "Get Basic",
    theme: {
      cardBg: "bg-indigo-950/40 backdrop-blur-sm",
      borderColor: "border-indigo-800/80",
      iconColor: "text-indigo-400 bg-indigo-900/50",
      btnColor:
        "bg-indigo-600 hover:bg-indigo-500 text-white shadow-lg shadow-indigo-900/50",
      textColor: "text-indigo-200",
      priceColor: "text-white",
    },
  },
  {
    name: "Premium",
    icon: <Crown size={28} />,
    monthlyPrice: { INR: 2000, USD: 24 },
    semiAnnualPrice: { INR: 10800, USD: 129.6 },
    duration: isAnnual ? "/ 6 months" : "/ month",
    desc: "Ultimate study toolkit for heavy users, detailed exam prep, and multi-document analysis.",
    features: [
      `${isAnnual ? "6,000" : "1,000"} AI Chat Queries`, // Updated to 1000/6000
      "Multi-PDF Upload Support",
      "In-depth Complex Problem Solving",
      "Priority Server Access",
      "Export Solutions to PDF",
    ],
    buttonText: "Upgrade to Premium",
    highlighted: true,
    theme: {
      cardBg: "bg-blue-950/60 backdrop-blur-sm",
      borderColor:
        "border-blue-500 ring-2 ring-blue-500 shadow-2xl shadow-blue-900/40",
      iconColor: "text-blue-400 bg-blue-900/60",
      btnColor:
        "bg-blue-600 hover:bg-blue-500 text-white shadow-lg shadow-blue-900/50",
      textColor: "text-blue-200",
      priceColor: "text-white",
    },
  },
  {
    name: "Institution",
    icon: <Building2 size={28} />,
    monthlyPrice: { INR: "Custom", USD: "Custom" },
    semiAnnualPrice: { INR: "Custom", USD: "Custom" },
    duration: "",
    desc: "Tailored solutions built for schools, colleges, and tutoring centers.",
    features: [
      "Unlimited Student Queries",
      "School-wide Custom Deployment",
      "Dedicated Server Infrastructure",
      "Admin Analytics Dashboard",
    ],
    buttonText: "Contact Sales",
    isCustom: true,
    theme: {
      cardBg: "bg-purple-950/40 backdrop-blur-sm",
      borderColor: "border-purple-800/80",
      iconColor: "text-purple-400 bg-purple-900/50",
      btnColor:
        "bg-purple-600 hover:bg-purple-500 text-white shadow-lg shadow-purple-900/50",
      textColor: "text-purple-200",
      priceColor: "text-white",
    },
  },
];

export default function PSTVueSubscription() {
  const [showContactPopup, setShowContactPopup] = useState(false);
  const [isAnnual, setIsAnnual] = useState(false);
  const navigate = useNavigate();

  const plans = getPlans(isAnnual);

  const handleSubscribe = (planName) => {
    if (planName === "Institution") {
      setShowContactPopup(true);
    } else {
      navigate("/login");
    }
  };

  return (
    <div>
      <Navbar />
      <div className="bg-[#04254d] min-h-screen py-16 px-4 font-sans text-slate-300 selection:bg-blue-500/30">
        {/* BACKGROUND GLOW EFFECTS */}
        <div className="fixed inset-0 overflow-hidden pointer-events-none">
          <div className="absolute -top-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-blue-900/20 blur-[120px]" />
          <div className="absolute top-[20%] -right-[10%] w-[40%] h-[40%] rounded-full bg-purple-900/20 blur-[120px]" />
        </div>

        {/* HEADER */}
        <div className="relative max-w-5xl mx-auto text-center mb-12 px-4 z-10">
          <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-6 drop-shadow-md">
            Transparent Pricing for Every Learner
          </h1>
          <p className="mb-2 text-slate-400 text-lg font-medium">
            No hidden fees. No complications. Start with a 14-day free trial —
            no payment required.
          </p>
          <p className="text-slate-400 text-lg font-medium">
            Choose the plan that fits your needs and scale with confidence.
          </p>
        </div>

        {/* FREE TRIAL BOX */}
        <div className="relative z-10 bg-emerald-950/40 border border-emerald-800/60 max-w-3xl mx-auto p-6 rounded-2xl shadow-xl mb-12 text-center transform transition hover:scale-[1.02] backdrop-blur-sm">
          <h2 className="text-2xl font-bold mb-2 text-emerald-400">
            Try Any Plan Risk-Free
          </h2>
          <p className="text-emerald-200/80 mb-5 font-medium">
            Start your 14-day free trial today. No payment required upfront —
            get full access to transform your learning.
          </p>
          <div className="flex flex-col md:flex-row justify-center items-center gap-4">
            <span className="flex items-center gap-2 text-emerald-300 text-sm font-bold bg-emerald-900/50 border border-emerald-800/50 px-4 py-1.5 rounded-full shadow-sm">
              ✅ No credit card needed
            </span>

            <span className="flex items-center gap-2 text-purple-300 text-sm font-bold bg-purple-900/50 border border-purple-800/50 px-4 py-1.5 rounded-full shadow-sm">
              ✅ Full access during trial
            </span>
          </div>
        </div>

        {/* BILLING TOGGLE */}
        <div className="relative z-10 flex justify-center mb-14">
          <div className="flex shadow-lg rounded-lg overflow-hidden border border-slate-700 bg-slate-900 p-1">
            <button
              onClick={() => setIsAnnual(false)}
              className={`px-8 py-2.5 font-bold text-base rounded-md transition-all ${
                !isAnnual
                  ? "bg-blue-600 text-white shadow-md"
                  : "text-slate-400 hover:text-slate-200 hover:bg-slate-800"
              }`}
            >
              Monthly
            </button>
            <button
              onClick={() => setIsAnnual(true)}
              className={`px-8 py-2.5 font-bold text-base rounded-md transition-all flex items-center gap-2 ${
                isAnnual
                  ? "bg-blue-600 text-white shadow-md"
                  : "text-slate-400 hover:text-slate-200 hover:bg-slate-800"
              }`}
            >
              Semi-Annual{" "}
              <span className="text-[10px] bg-yellow-500/20 text-yellow-400 border border-yellow-500/30 px-2 py-0.5 rounded-full uppercase tracking-wider">
                Save 10%
              </span>
            </button>
          </div>
        </div>

        {/* PRICING CARDS */}
        <div className="relative z-10 max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {plans.map((plan, index) => {
            return (
              <div
                key={index}
                className={`relative rounded-3xl p-7 border transition-all duration-300 transform hover:-translate-y-2 flex flex-col ${plan.theme.cardBg} ${plan.theme.borderColor} ${plan.highlighted ? "scale-105 z-20" : "z-10"}`}
              >
                {plan.highlighted && (
                  <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-gradient-to-r from-blue-500 to-indigo-500 text-white px-6 py-1.5 rounded-full text-xs font-black shadow-lg uppercase tracking-wider border border-blue-400/50">
                    Most Popular
                  </div>
                )}

                <div className="flex items-center gap-4 mb-6">
                  <div
                    className={`p-3 rounded-xl shadow-inner border border-white/5 ${plan.theme.iconColor}`}
                  >
                    {plan.icon}
                  </div>
                  <h3 className="text-2xl font-black text-white">
                    {plan.name}
                  </h3>
                </div>

                <div className="mb-6 min-h-[95px]">
                  {plan.isCustom ? (
                    <div className="text-4xl font-extrabold text-white mt-2">
                      Custom Pricing
                    </div>
                  ) : (
                    <div>
                      {!isAnnual ? (
                        <div>
                          <span
                            className={`text-4xl font-extrabold ${plan.theme.priceColor}`}
                          >
                            ${plan.monthlyPrice.USD}
                          </span>
                          <span className="text-xl font-bold text-slate-500">
                            {" "}
                            / ₹{plan.monthlyPrice.INR}
                          </span>
                        </div>
                      ) : (
                        <div className="flex flex-col">
                          {plan.monthlyPrice.USD > 0 && (
                            <span className="text-lg line-through text-slate-600 font-bold mb-1">
                              ${plan.monthlyPrice.USD * 6} / ₹
                              {plan.monthlyPrice.INR * 6}
                            </span>
                          )}
                          <div>
                            <span className="text-4xl font-extrabold text-emerald-400">
                              ${plan.semiAnnualPrice.USD}
                            </span>
                            <span className="text-xl font-bold text-slate-500">
                              {" "}
                              / ₹{plan.semiAnnualPrice.INR}
                            </span>
                          </div>
                        </div>
                      )}
                      <div className="text-sm font-bold text-slate-500 mt-2">
                        {plan.duration}
                      </div>
                    </div>
                  )}
                </div>

                <p
                  className={`font-medium mb-6 flex-grow leading-relaxed ${plan.theme.textColor}`}
                >
                  {plan.desc}
                </p>

                <ul className="text-sm font-medium text-slate-300 mb-8 space-y-4">
                  {plan.features.map((f, i) => (
                    <li key={i} className="flex items-start gap-3">
                      <CheckCircle2
                        size={20}
                        className={`${plan.highlighted ? "text-blue-400" : "text-emerald-500"} shrink-0`}
                      />
                      <span className="leading-snug">{f}</span>
                    </li>
                  ))}
                </ul>

                <button
                  onClick={() => handleSubscribe(plan.name)}
                  className={`w-full py-3.5 rounded-xl font-bold text-base transition-all hover:scale-[1.02] ${plan.theme.btnColor}`}
                >
                  {plan.buttonText}
                </button>
              </div>
            );
          })}
        </div>

        {/* FEATURE COMPARISON */}
        <div className="relative z-10 max-w-6xl mx-auto mt-24 rounded-2xl shadow-2xl p-1 bg-slate-900/50 backdrop-blur-md overflow-hidden border border-slate-800">
          <div className="p-8 bg-slate-900 rounded-xl">
            <h3 className="text-3xl font-extrabold mb-8 text-white text-center">
              Detailed Feature Comparison
            </h3>
            <div className="overflow-x-auto">
              <table className="w-full border-collapse">
                <thead>
                  <tr className="border-b border-slate-800">
                    <th className="py-5 px-6 text-left font-bold text-slate-300 text-lg uppercase tracking-wider text-sm">
                      Features
                    </th>
                    <th className="py-5 px-6 text-left font-bold text-slate-300 text-lg uppercase tracking-wider text-sm">
                      Free
                    </th>
                    <th className="py-5 px-6 text-left font-bold text-indigo-400 text-lg uppercase tracking-wider text-sm">
                      Basic
                    </th>
                    <th className="py-5 px-6 text-left font-bold text-blue-400 text-lg uppercase tracking-wider text-sm">
                      Premium
                    </th>
                    <th className="py-5 px-6 text-left font-bold text-purple-400 text-lg uppercase tracking-wider text-sm">
                      Institution
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-800/60">
                  <tr className="hover:bg-slate-800/40 transition-colors">
                    <td className="py-5 px-6 font-semibold text-slate-200">
                      AI Queries (Monthly)
                    </td>
                    <td className="py-5 px-6 text-slate-400">20 (Total)</td>
                    <td className="py-5 px-6 text-slate-400">500</td>
                    <td className="py-5 px-6 text-blue-400 font-bold">1,000</td>
                    <td className="py-5 px-6 text-slate-400">Unlimited</td>
                  </tr>
                  <tr className="hover:bg-slate-800/40 transition-colors">
                    <td className="py-5 px-6 font-semibold text-slate-200">
                      PDF Support
                    </td>
                    <td className="py-5 px-6 text-slate-400">Standard</td>
                    <td className="py-5 px-6 text-slate-400">
                      Advanced Parsing
                    </td>
                    <td className="py-5 px-6 text-blue-400 font-bold">
                      Multi-PDF Support
                    </td>
                    <td className="py-5 px-6 text-slate-400">
                      Custom Integration
                    </td>
                  </tr>
                  <tr className="hover:bg-slate-800/40 transition-colors">
                    <td className="py-5 px-6 font-semibold text-slate-200">
                      Performance
                    </td>
                    <td className="py-5 px-6 text-slate-400">Standard</td>
                    <td className="py-5 px-6 text-slate-400">Faster</td>
                    <td className="py-5 px-6 text-blue-400 font-bold">
                      Priority Server
                    </td>
                    <td className="py-5 px-6 text-slate-400">
                      Dedicated Infra
                    </td>
                  </tr>
                  <tr className="hover:bg-slate-800/40 transition-colors">
                    <td className="py-5 px-6 font-semibold text-slate-200">
                      Extra Tools
                    </td>
                    <td className="py-5 px-6 text-slate-600">—</td>
                    <td className="py-5 px-6 text-slate-400">Chat History</td>
                    <td className="py-5 px-6 text-blue-400 font-bold">
                      Export to PDF
                    </td>
                    <td className="py-5 px-6 text-slate-400">
                      Admin Dashboard
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="relative z-10 max-w-4xl mx-auto mt-16 text-slate-200">
          <FAQ />
        </div>

        {/* CONTACT POPUP */}
        {showContactPopup && (
          <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4">
            <div className="bg-slate-900 rounded-3xl p-10 max-w-md w-full text-center shadow-2xl border border-slate-700">
              <div className="flex items-center justify-center mb-6">
                <div className="bg-slate-800 p-4 rounded-full border border-slate-700">
                  <img
                    src={MNR}
                    alt="MNR"
                    className="w-16 h-16 object-contain drop-shadow-lg"
                  />
                </div>
              </div>
              <h2 className="text-3xl font-extrabold mb-4 text-white">
                Contact Sales
              </h2>
              <p className="text-slate-400 mb-8 text-lg font-medium">
                Ready to scale? Email us directly to build a custom plan for
                your institution.
                <br />
                <br />
                <a
                  href="mailto:sales@mnrtechnologies.com"
                  className="text-blue-400 hover:text-blue-300 font-bold text-xl transition-colors"
                >
                  sales@mnrtechnologies.com
                </a>
              </p>
              <button
                onClick={() => setShowContactPopup(false)}
                className="w-full bg-blue-600 text-white px-8 py-3.5 rounded-xl font-bold text-lg hover:bg-blue-500 transition-colors shadow-lg shadow-blue-900/20"
              >
                Close Window
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}